import { I18nString } from "@oebb-web-team/oebb-web-library/dist/i18n/OebbI18n";

export const corpApartmentI18n: I18nString[] = [
    {
        key: "apartment.filter.type",
        de: "Art der Wohnung",
        en: "Apartment type",
    },
    {
        key: "apartment.filter.region",
        de: "Region",
        en: "Region",
    },
    {
        key: "apartment.filter.province",
        de: "Bundesland",
        en: "State",
    },
    {
        key: "apartment.filter.postalCode",
        de: "PLZ",
        en: "Postal code",
    },
    {
        key: "apartment.filter.town",
        de: "Ort",
        en: "Town",
    },
    {
        key: "apartment.filter.street",
        de: "Straße",
        en: "Street",
    },
    {
        key: "apartment.filter.size",
        de: "Fläche",
        en: "Size",
    },
    {
        key: "apartment.filter.sizeFrom",
        de: "Fläche ab",
        en: "Size from",
    },
    {
        key: "apartment.filter.sizeTo",
        de: "Fläche bis",
        en: "Size to",
    },
    {
        key: "apartment.filter.rent",
        de: "Miete",
        en: "Rent",
    },
    {
        key: "apartment.filter.rentFrom",
        de: "Miete ab",
        en: "Rent from",
    },
    {
        key: "apartment.filter.rentTo",
        de: "Miete bis",
        en: "Rent to",
    },
    {
        key: "apartment.filter.rooms",
        de: "Zimmer",
        en: "Rooms",
    },
    {
        key: "apartment.filter.roomsFrom",
        de: "Zimmer ab",
        en: "Rooms from",
    },
    {
        key: "apartment.filter.roomsTo",
        de: "Zimmer bis",
        en: "Rooms to",
    },
    {
        key: "apartment.filter.depositTo",
        de: "Kaution bis",
        en: "Deposit to",
    },
    {
        key: "apartment.filter.features",
        de: "Eigenschaften",
        en: "Features",
    },
    {
        key: "apartment.filter.search",
        de: "Wohnungen finden",
        en: "Find apartments",
    },
    {
        key: "apartment.filter.reset",
        de: "Filter zurücksetzen",
        en: "Reset filter",
    },
    {
        key: "apartment.filter.hide",
        de: "Filter ausblenden",
        en: "Hide filter",
    },
    {
        key: "apartment.filter.show",
        de: "Filter öffnen",
        en: "Show filter",
    },
    {
        key: "apartment-.filter.results-single",
        de: "Ein Ergebnis anzeigen",
        en: "Show one result",
    },
    {
        key: "apartment.filter.results-multiple",
        de: "{0} Ergebnisse anzeigen",
        en: "Show {0} results",
    },
    {
        key: "apartment.types.Genossenschaftswohnung",
        de: "Genossenschaftswohnung",
        en: "Cooperative apartment",
    },
    {
        key: "apartment.types.OebbMitarbeiterwohnung",
        de: "ÖBB Mitarbeiter:innenwohnung",
        en: "ÖBB employee apartment",
    },
    {
        key: "apartment.regions.Ost",
        de: "Ost",
        en: "East",
    },
    {
        key: "apartment.regions.Mitte",
        de: "Mitte",
        en: "Central",
    },
    {
        key: "apartment.regions.Süd",
        de: "Süd",
        en: "South",
    },
    {
        key: "apartment.regions.West",
        de: "West",
        en: "West",
    },
    {
        key: "apartment.regions.unknown",
        de: "nicht bekannt",
        en: "unknown",
    },
    {
        key: "apartment.provinces.Burgenland",
        de: "Burgenland",
        en: "Burgenland",
    },
    {
        key: "apartment.provinces.Kärnten",
        de: "Kärnten",
        en: "Carinthia",
    },
    {
        key: "apartment.provinces.Niederösterreich",
        de: "Niederösterreich",
        en: "Lower Austria",
    },
    {
        key: "apartment.provinces.Oberösterreich",
        de: "Oberösterreich",
        en: "Upper Austria",
    },
    {
        key: "apartment.provinces.Salzburg",
        de: "Salzburg",
        en: "Salzburg",
    },
    {
        key: "apartment.provinces.Steiermark",
        de: "Steiermark",
        en: "Styria",
    },
    {
        key: "apartment.provinces.Tirol",
        de: "Tirol",
        en: "Tyrol",
    },
    {
        key: "apartment.provinces.Vorarlberg",
        de: "Vorarlberg",
        en: "Vorarlberg",
    },
    {
        key: "apartment.provinces.Wien",
        de: "Wien",
        en: "Vienna",
    },
    {
        key: "apartment.features.balcony",
        de: "Balkon/Loggia",
        en: "Balcony/Loggia",
    },
    {
        key: "apartment.features.elevator",
        de: "Lift",
        en: "Elevator",
    },
    {
        key: "apartment.features.accessible",
        de: "Barrierearm",
        en: "Accessible",
    },
    {
        key: "apartment.features.terrace",
        de: "Terrasse/Eigengarten",
        en: "Patio/Garden",
    },
    {
        key: "apartment.features.housingSubsidies",
        de: "Wohnungsförderung",
        en: "Housing subsidies",
    },
    {
        key: "apartment.format.rooms",
        de: "{0} Zimmer",
        en: "{0} rooms",
    },
    {
        key: "apartment.format.rent.from",
        de: "ab {0}",
        en: "from {0}",
    },
    {
        key: "apartment.list.loading",
        de: "Wohnungen werden geladen...",
        en: "Loading apartments...",
    },
    {
        key: "apartment.list.error",
        de: "Fehler beim Laden der Wohnungen. Bitte später noch einmal versuchen.",
        en: "Error loading apartments. Please try again later.",
    },
    {
        key: "apartment.list.no-matching",
        de: "Es konnten keine passenden Wohnungen gefunden werden.",
        en: "No matching apartments found.",
    },
    {
        key: "apartment.searchagent.button.label",
        de: "Suchagent erstellen",
        en: "Create searchagent",
    },
    {
        key: "apartment.searchagent.title.label",
        de: "Titel",
        en: "Title",
    },
    {
        key: "apartment.searchagent.title",
        de: "Titel",
        en: "Title",
    },
    {
        key: "apartment.searchagent.title.help",
        de: "Titel",
        en: "Title",
    },
    {
        key: "apartment.searchagent.email.label",
        de: "E-Mail",
        en: "E-Mail",
    },
    {
        key: "apartment.searchagent.email",
        de: "E-Mail",
        en: "E-Mail",
    },
    {
        key: "apartment.searchagent.email.help",
        de: "E-Mail",
        en: "E-Mail",
    },
    {
        key: "apartment.searchagent.label",
        de: "Suchagent",
        en: "Searchagent",
    },
    {
        key: "apartment.searchagent.gdprLink",
        de: "Informationen zum Datenschutz",
        en: "Information on data protection",
    },
    {
        key: "apartment.searchagent.explanatoryVideo",
        de: "So erstellst du einen Suchagenten",
        en: "How to create a search agent",
    },
    {
        key: "apartment.searchagent.dialog.close",
        de: "Dialog schließen",
        en: "Close dialog",
    },
    {
        key: "apartment.searchagent.title.errorMessage",
        de: "Das Eingabefeld darf nicht leer sein oder Sonderzeichen enthalten.",
        en: "The input field cannot be empty or contain special characters.",
    },
    {
        key: "apartment.searchagent.email.errorMessage",
        de: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
        en: "Please enter a valid email address.",
    },
    {
        key: "apartment.searchagent.cancel",
        de: "Abbrechen",
        en: "Cancel",
    },
    {
        key: "apartment.searchagent.confirm",
        de: "Erstellen",
        en: "Confirm",
    },
    {
        key: "apartment.searchagent.message.create.success",
        de: "Dein Suchagent wurde erfolgreich erstellt! Bitte überprüfe deine E-Mails, um den Suchagenten zu aktivieren.",
        en: "Your search agent has been successfully created! Please check your email to activate the search agent.",
    },
    {
        key: "apartment.searchagent.message.create.error",
        de: "Beim Erstellen des Suchagenten ist ein Fehler aufgetreten. Bitte versuche es erneut.",
        en: "An error occurred while creating the search agent. Please try again.",
    },
    {
        key: "apartment.searchagent.message.create.info",
        de: "Bitte verwende den Filter, um einen Suchagenten zu erstellen.",
        en: "Please use the filter to create a search agent.",
    },
    {
        key: "apartment.searchagent.message.activation.success",
        de: "Dein Suchagent wurde erfolgreich aktiviert.",
        en: "Your search agent has been successfully activated.",
    },
    {
        key: "apartment.searchagent.message.activation.error",
        de: "Leider ist bei der Aktivierung ein Fehler aufgetreten. Bitte versuche es erneut.",
        en: "Unfortunately, an error occurred during activation. Please try again.",
    },
    {
        key: "apartment.searchagent.message.deletion.success",
        de: "Dein Suchagent wurde erfolgreich gelöscht.",
        en: "Your search agent has been successfully deleted.",
    },
    {
        key: "apartment.searchagent.message.deletion.error",
        de: "Leider ist bei der Abmeldung ein Fehler aufgetreten. Bitte versuche es erneut.",
        en: "Unfortunately, an error occurred while unsubscribing. Please try again.",
    },
];
